import { useMutation } from "@tanstack/react-query";
import { StudentInformationWithTokenProps, ProfileService } from "../services/profile";


export function useUpdateStudentInformation() {
   const { mutate, isLoading, reset, isSuccess, isError, error, mutateAsync } = useMutation({
      mutationFn: (props: StudentInformationWithTokenProps) => ProfileService.postStudentInformation(props)
   })

   return {
      mutate,
      mutateAsync,
      isLoading,
      reset,
      isSuccess,
      isError,
      error,
   };
}